<div class="mt-8 mb-6">



    <div class="w-full flex justify-between items-center mb-6">
        <app-btn-back routeTo=".."></app-btn-back>
    </div>

    @if (group?.groupType === 'church') {
    <!-- Church split layout -->
    <div class="flex flex-col md:flex-row gap-4 w-full items-start">
        <!-- Left: Calendar Card -->
        <div class="flex-1 bg-white rounded-2xl shadow-xl border border-blueGray-100 overflow-hidden w-full">
            <!-- Calendar Navigation Header -->
            <div
                class="bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-5 flex items-center justify-between text-white">
                <div class="flex items-center gap-4">
                    <h1 class="text-2xl font-bold tracking-tight">Event Management</h1>
                </div>
                <div class="flex items-center gap-6">
                    <button (click)="prevMonth()"
                        class="p-2 hover:bg-white/10 rounded-full transition-colors focus:outline-none"
                        title="Previous Month">
                        <i class="fa fa-chevron-left text-lg"></i>
                    </button>
                    <span class="text-xl font-bold tracking-wide min-w-[150px] text-center">
                        {{ selectedDate.format('MMMM YYYY') }}
                    </span>
                    <button (click)="nextMonth()"
                        class="p-2 hover:bg-white/10 rounded-full transition-colors focus:outline-none"
                        title="Next Month">
                        <i class="fa fa-chevron-right text-lg"></i>
                    </button>
                </div>
            </div>

            <!-- Calendar Table Grid -->
            <div class="p-4">
                @if (!loading) {
                <table class="w-full table-fixed border-collapse border border-blueGray-200">
                    <thead>
                        <tr class="bg-blueGray-50">
                            <th *ngFor="let day of weekdays"
                                class="text-xs font-bold uppercase text-blueGray-500 py-3 text-center border border-blueGray-200">
                                {{ day }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let week of weeks">
                            <tr>
                                <td *ngFor="let day of week" class="p-0 border border-blueGray-200 align-top">
                                    <div (click)="selectDay(day.date)" [ngClass]="{
                                                'bg-primary-50/10 ring-2 ring-primary-500 ring-inset z-10': selectedDay && day.date.isSame(selectedDay, 'day'),
                                                'bg-blueGray-50/50 text-blueGray-400': (!selectedDay || !day.date.isSame(selectedDay, 'day')) && !day.isCurrentMonth,
                                                'bg-white text-blueGray-700': (!selectedDay || !day.date.isSame(selectedDay, 'day')) && day.isCurrentMonth
                                             }"
                                        class="relative min-h-[75px] aspect-square p-0 cursor-pointer hover:bg-primary-50/20 transition-all duration-150 flex flex-col justify-between w-full h-full">
                                        <!-- Date Number -->
                                        <div class="flex justify-between items-start p-2">
                                            <span style="border-radius: 50%;"
                                                class="text-sm font-semibold h-7 w-7 flex items-center justify-center rounded-full"
                                                [ngClass]="{
                                                    'bg-primary-600 text-white rounded-full font-bold shadow-sm': selectedDay && day.date.isSame(selectedDay, 'day'),
                                                    'bg-primary-100 text-primary-700 rounded-full font-bold': day.isToday && !(selectedDay && day.date.isSame(selectedDay, 'day')),
                                                    'text-blueGray-700': day.isCurrentMonth && !(selectedDay && day.date.isSame(selectedDay, 'day')) && !day.isToday,
                                                    'text-blueGray-400': !day.isCurrentMonth && !(selectedDay && day.date.isSame(selectedDay, 'day')) && !day.isToday
                                                }">
                                                {{ day.date.date() }}
                                            </span>
                                        </div>

                                        <!-- Event dots indicators -->
                                        <div class="flex flex-row justify-center gap-1.5 pb-2">
                                            <span *ngFor="let ev of day.events" class="h-2 w-2 rounded-full" [ngClass]="{
                                                    'bg-rose-500': ev.type === 'birthday',
                                                    'bg-indigo-500': ev.type === 'notice'
                                                }"></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <!-- Mobile Daily Events Collapse Card -->
                            @if (isMobile && weekContainsSelectedDay(week)) {
                            <tr class="md:hidden">
                                <td colspan="7" class="bg-blueGray-50/50 p-4 border border-blueGray-200">
                                    <div
                                        class="bg-white rounded-xl border border-blueGray-200/80 p-4 shadow-sm text-left">
                                        <h4 class="text-sm font-bold text-blueGray-800 mb-3 flex items-center gap-2">
                                            <i class="fa fa-calendar-day text-primary-500"></i>
                                            Events for {{ selectedDay?.format('DD MMMM YYYY') }}
                                        </h4>
                                        <div *ngIf="selectedDayEvents.length === 0"
                                            class="text-xs text-blueGray-400 py-4 text-center">
                                            No events scheduled for this day.
                                        </div>
                                        <div *ngIf="selectedDayEvents.length > 0" class="space-y-3">
                                            <div *ngFor="let event of selectedDayEvents" (click)="selectEvent(event)"
                                                class="p-3 rounded-lg border border-blueGray-100 hover:border-primary-500 cursor-pointer bg-blueGray-50/20">
                                                <div class="flex justify-between items-center mb-1">
                                                    <span
                                                        class="text-[10px] font-bold px-2 py-0.5 rounded-full uppercase"
                                                        [ngClass]="{
                                                            'bg-rose-100 text-rose-800': event.type === 'birthday',
                                                            'bg-indigo-100 text-indigo-800': event.type === 'notice'
                                                        }">
                                                        {{ event.type }}
                                                    </span>
                                                    <span *ngIf="event.volunteersRequired > 0"
                                                        class="text-[10px] font-semibold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded-full">
                                                        {{ event.volunteers?.length || 0 }} / {{
                                                        event.volunteersRequired }} Vol.
                                                    </span>
                                                </div>
                                                <div class="font-bold text-sm text-blueGray-800">{{ event.name }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            }
                        </ng-container>
                    </tbody>
                </table>
                } @else {
                <div class="h-64 flex flex-col justify-center items-center w-full">
                    <app-loading-dots color="bg-primary-500"></app-loading-dots>
                    <span class="text-sm text-blueGray-400 mt-2">Loading calendar events...</span>
                </div>
                }
            </div>
        </div>

        <!-- Right: Daily Events Card (Large screens only) -->
        <div class="hidden md:block w-full md:w-[350px] lg:w-[450px]">
            <div class="bg-white rounded-2xl shadow-xl border border-blueGray-100 p-6 h-full min-h-[500px]">
                <h2 class="text-lg font-bold text-blueGray-800 mb-4 flex items-center gap-2">
                    <i class="fa fa-calendar-day text-primary-500"></i>
                    Events for {{ selectedDay?.format('DD MMMM YYYY') }}
                </h2>
                <div *ngIf="selectedDayEvents.length === 0" class="text-center py-12 text-sm text-blueGray-400">
                    No events scheduled for this day.
                </div>
                <div *ngIf="selectedDayEvents.length > 0" class="space-y-4">
                    <div *ngFor="let event of selectedDayEvents" (click)="selectEvent(event)"
                        class="p-4 rounded-xl border border-blueGray-200 hover:border-primary-500 cursor-pointer transition-all duration-150 shadow-sm hover:shadow bg-blueGray-50/30">
                        <div class="flex justify-between items-start mb-2">
                            <span class="text-xs font-bold px-2.5 py-0.5 rounded-full uppercase tracking-wider"
                                [ngClass]="{
                                    'bg-rose-100 text-rose-800': event.type === 'birthday',
                                    'bg-indigo-100 text-indigo-800': event.type === 'notice'
                                }">
                                {{ event.type }}
                            </span>
                            <span *ngIf="event.volunteersRequired > 0"
                                class="text-xs font-semibold text-emerald-600 bg-emerald-50 px-2 py-0.5 rounded-full">
                                Volunteers: {{ event.volunteers?.length || 0 }} / {{ event.volunteersRequired }}
                            </span>
                        </div>
                        <h3 class="font-bold text-blueGray-800 text-base mb-1">{{ event.name }}</h3>
                        <p class="text-sm text-blueGray-500 line-clamp-2">{{ event.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    } @else {
    <!-- Calendar Card Container -->
    <div class="bg-white rounded-2xl shadow-xl border border-blueGray-100 overflow-hidden">

        <!-- Calendar Header Navigation -->
        <div
            class="bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-5 flex items-center justify-between text-white">
            <div class="flex items-center gap-4">
                <h1 class="text-2xl font-bold tracking-tight">Events Calendar</h1>
            </div>

            <div class="flex items-center gap-6">
                <button (click)="prevMonth()"
                    class="p-2 hover:bg-white/10 rounded-full transition-colors focus:outline-none"
                    title="Previous Month">
                    <i class="fa fa-chevron-left text-lg"></i>
                </button>
                <span class="text-xl font-bold tracking-wide min-w-[150px] text-center">
                    {{ selectedDate.format('MMMM YYYY') }}
                </span>
                <button (click)="nextMonth()"
                    class="p-2 hover:bg-white/10 rounded-full transition-colors focus:outline-none" title="Next Month">
                    <i class="fa fa-chevron-right text-lg"></i>
                </button>
            </div>
        </div>

        <!-- Main Calendar Layout - removed p-6 padding to make cells wider -->
        <div class="min-h-[500px]">
            <!-- Calendar Table Grid -->
            @if (!loading) {
            <table class="w-full table-fixed border-collapse border border-blueGray-200">
                <thead>
                    <tr class="bg-blueGray-50">
                        <th *ngFor="let day of weekdays"
                            class="text-xs font-bold uppercase text-blueGray-500 py-3 text-center border border-blueGray-200">
                            {{ day }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let week of weeks">
                        <td *ngFor="let day of week" class="p-0 border border-blueGray-200 align-top">
                            <div (click)="selectDay(day.date)" [ngClass]="{
                                        'bg-primary-50/10 ring-2 ring-primary-500 ring-inset z-10': selectedDay && day.date.isSame(selectedDay, 'day'),
                                        'bg-blueGray-50/50 text-blueGray-400': (!selectedDay || !day.date.isSame(selectedDay, 'day')) && !day.isCurrentMonth,
                                        'bg-white text-blueGray-700': (!selectedDay || !day.date.isSame(selectedDay, 'day')) && day.isCurrentMonth
                                     }"
                                class="relative min-h-[160px] p-0 cursor-pointer hover:bg-primary-50/20 transition-all duration-150 flex flex-col justify-start gap-2.5 w-full h-full">

                                <!-- Date Number - added rounded-full to base class to ensure circles are always perfectly round -->
                                <div class="flex justify-between items-start p-2.5">
                                    <span style="border-radius: 50%;"
                                        class="text-sm font-semibold h-7 w-7 flex items-center justify-center rounded-full"
                                        [ngClass]="{
                                            'bg-primary-600 text-white rounded-full font-bold shadow-sm': selectedDay && day.date.isSame(selectedDay, 'day'),
                                            'bg-primary-100 text-primary-700 rounded-full font-bold': day.isToday && !(selectedDay && day.date.isSame(selectedDay, 'day')),
                                            'text-blueGray-700': day.isCurrentMonth && !(selectedDay && day.date.isSame(selectedDay, 'day')) && !day.isToday,
                                            'text-blueGray-400': !day.isCurrentMonth && !(selectedDay && day.date.isSame(selectedDay, 'day')) && !day.isToday
                                        }">
                                        {{ day.date.date() }}
                                    </span>
                                </div>

                                <!-- Events List -->
                                <div class="flex flex-col gap-1.5 w-full flex-grow px-1.25 pb-1.25">
                                    <ng-container *ngFor="let event of day.events">
                                        <!-- Birthday Event -->
                                        @if (event.type === 'birthday') {
                                        <div (click)="onBirthdayClick(event); $event.stopPropagation()"
                                            class="bg-rose-50 border border-rose-100 text-rose-800 text-[11px] p-1 flex items-center gap-1 hover:bg-rose-100/50 transition-colors duration-150 cursor-pointer mx-1"
                                            [title]="'Birthday: ' + event.name">
                                            <span class="text-sm leading-none select-none">🎂</span>
                                            @if (event.photoURL) {
                                            <img [src]="event.photoURL"
                                                class="w-4 h-4 min-w-4 min-h-4 max-w-4 max-h-4 rounded-full object-cover select-none"
                                                alt="" />
                                            }
                                            <span class="truncate font-semibold">{{ event.name }}</span>
                                        </div>
                                        }

                                        <!-- Notice Event -->
                                        @if (event.type === 'notice') {
                                        <div (click)="onNoticeClick(event); $event.stopPropagation()"
                                            class="bg-indigo-50 border border-indigo-100 hover:bg-indigo-100 hover:border-indigo-200 text-indigo-950 text-[11px] p-2 rounded-lg cursor-pointer transition-all duration-150 flex flex-col gap-1 shadow-sm hover:shadow mx-1"
                                            [title]="event.name">
                                            <div class="font-bold text-indigo-900 line-clamp-2 leading-tight">
                                                {{ event.name }}
                                            </div>
                                            <div
                                                class="text-indigo-900/80 line-clamp-3 leading-normal font-normal whitespace-pre-line">
                                                {{ event.description }}
                                            </div>
                                        </div>
                                        }
                                    </ng-container>
                                </div>

                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            } @else {
            <!-- Loading Spinner Inside Calendar Grid -->
            <div class="h-64 flex flex-col justify-center items-center w-full">
                <app-loading-dots color="bg-primary-500"></app-loading-dots>
                <span class="text-sm text-blueGray-400 mt-2">Loading calendar events...</span>
            </div>
            }
        </div>
    </div>
    }
</div>

<!-- Slide-over event details drawer -->
<div *ngIf="selectedEvent" class="fixed inset-0 z-50 overflow-hidden" aria-labelledby="slide-over-title" role="dialog"
    aria-modal="true">
    <div class="absolute inset-0 overflow-hidden">
        <!-- Backdrop -->
        <div (click)="closeDrawer()"
            class="absolute inset-0 bg-blueGray-900/60 backdrop-blur-sm transition-opacity duration-300 ease-in-out">
        </div>

        <!-- Slide-over panel -->
        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
            <div
                class="pointer-events-auto w-screen max-w-md transform transition-all duration-300 ease-in-out translate-x-0 bg-white shadow-2xl flex flex-col h-full border-l border-blueGray-100">
                <!-- Header -->
                <div
                    class="bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-5 flex items-center justify-between text-white shadow-md">
                    <div class="flex items-center gap-3">
                        <h2 class="text-lg font-bold tracking-wide" id="slide-over-title">Event Details</h2>
                        <button *ngIf="isAdminRole() && selectedEvent.type === 'notice'" (click)="onEditEvent(selectedEvent)"
                            class="text-xs font-bold bg-white/20 hover:bg-white/30 text-white px-2.5 py-1 rounded-lg transition-colors flex items-center gap-1">
                            <i class="fa fa-edit"></i> Edit
                        </button>
                    </div>
                    <button (click)="closeDrawer()"
                        class="text-white hover:text-blueGray-200 transition-colors p-1.5 rounded-full hover:bg-white/10">
                        <i class="fa fa-times text-lg"></i>
                    </button>
                </div>

                <!-- Scrollable Body -->
                <div class="flex-1 overflow-y-auto px-6 py-6 space-y-6">
                    <!-- Event Metadata -->
                    <div>
                        <span
                            class="inline-block text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-2"
                            [ngClass]="{
                                'bg-rose-100 text-rose-800': selectedEvent.type === 'birthday',
                                'bg-indigo-100 text-indigo-800': selectedEvent.type === 'notice'
                            }">
                            {{ selectedEvent.type }}
                        </span>
                        <h1 class="text-2xl font-extrabold text-blueGray-800 leading-tight mb-2">{{ selectedEvent.name
                            }}</h1>
                        <p class="text-sm font-semibold text-primary-500 flex items-center gap-1.5">
                            <i class="fa fa-clock"></i>
                            {{ selectedEvent.parsedEventDate | moment:'dddd, DD MMMM YYYY at hh:mm A' }}
                        </p>
                    </div>

                    <hr class="border-blueGray-100" />

                    <!-- Description -->
                    <div>
                        <h3 class="text-xs font-bold uppercase text-blueGray-400 tracking-wider mb-2">Description</h3>
                        <p class="text-blueGray-600 text-sm whitespace-pre-line leading-relaxed">{{
                            selectedEvent.description }}</p>
                    </div>

                    <hr class="border-blueGray-100" />

                    <!-- Volunteer Management Card -->
                    <div class="bg-blueGray-50 border border-blueGray-200/80 rounded-2xl p-5 shadow-inner">
                        <div class="flex justify-between items-center mb-4">
                            <h3
                                class="text-sm font-extrabold text-blueGray-800 flex items-center gap-1.5 uppercase tracking-wide">
                                <i class="fa fa-hand-holding-heart text-emerald-500"></i>
                                Volunteers Needed
                            </h3>
                            <!-- Admin edit toggle -->
                            <button *ngIf="isAdminRole() && !isEditing" (click)="isEditing = true"
                                class="text-xs font-bold text-primary-500 hover:text-primary-600 flex items-center gap-1 bg-white border border-blueGray-200 px-2.5 py-1.5 rounded-lg shadow-sm">
                                <i class="fa fa-edit"></i> Request
                            </button>
                        </div>

                        <!-- Edit volunteer request form -->
                        <div *ngIf="isEditing" class="space-y-4">
                            <div>
                                <label class="block text-xs font-bold text-blueGray-600 uppercase mb-1">Volunteers
                                    Required</label>
                                <input type="number" min="0" [(ngModel)]="editVolunteersRequired"
                                    class="w-full rounded-xl border border-blueGray-200 px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:ring-0 outline-none" />
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-blueGray-600 uppercase mb-1">Eligibility
                                    Criteria</label>
                                <textarea rows="3" [(ngModel)]="editVolunteerCriteria"
                                    placeholder="e.g. Must be over 18, background checked, etc."
                                    class="w-full rounded-xl border border-blueGray-200 px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:ring-0 outline-none"></textarea>
                            </div>
                            <div class="flex gap-2 justify-end pt-1">
                                <button (click)="isEditing = false"
                                    class="px-3.5 py-1.5 text-xs font-semibold bg-white text-blueGray-700 border border-blueGray-200 rounded-lg hover:bg-blueGray-50">
                                    Cancel
                                </button>
                                <button (click)="saveVolunteerRequirements(selectedEvent)"
                                    class="px-4 py-1.5 text-xs font-bold bg-primary-500 text-white rounded-lg hover:bg-primary-600 shadow">
                                    Save Changes
                                </button>
                            </div>
                        </div>

                        <!-- View volunteer state -->
                        <div *ngIf="!isEditing">
                            <!-- If volunteers are requested -->
                            <div *ngIf="selectedEvent.volunteersRequired > 0; else noVolunteers">
                                <div class="flex justify-between text-xs font-bold text-blueGray-600 mb-1">
                                    <span>Progress</span>
                                    <span>{{ selectedEvent.volunteers?.length || 0 }} / {{
                                        selectedEvent.volunteersRequired }} Registered</span>
                                </div>
                                <div class="w-full bg-blueGray-200 rounded-full h-2.5 overflow-hidden">
                                    <div class="bg-emerald-500 h-2.5 rounded-full transition-all duration-300"
                                        [style.width.%]="(selectedEvent.volunteers?.length || 0) / selectedEvent.volunteersRequired * 100">
                                    </div>
                                </div>

                                <!-- Eligibility Criteria -->
                                <div *ngIf="selectedEvent.volunteerCriteria"
                                    class="mt-4 bg-white/60 p-3.5 rounded-xl border border-blueGray-200/50">
                                    <h4 class="text-xs font-bold text-blueGray-700 uppercase mb-1">Eligibility & Info
                                    </h4>
                                    <p class="text-xs text-blueGray-600 leading-relaxed">{{
                                        selectedEvent.volunteerCriteria }}</p>
                                </div>

                                <!-- Volunteer List -->
                                <div class="mt-4">
                                    <h4 class="text-xs font-bold text-blueGray-700 uppercase mb-1.5">Registered
                                        Volunteers</h4>
                                    <div *ngIf="!selectedEvent.volunteers || selectedEvent.volunteers.length === 0"
                                        class="text-xs text-blueGray-400 italic py-2">
                                        No volunteers registered yet.
                                    </div>
                                    <div *ngIf="selectedEvent.volunteers && selectedEvent.volunteers.length > 0"
                                        class="flex flex-wrap gap-1.5">
                                        <span *ngFor="let vol of selectedEvent.volunteers"
                                            class="inline-flex items-center gap-1 px-2.5 py-1 bg-white border border-blueGray-200 rounded-full text-xs font-medium text-blueGray-700">
                                            <i class="fa fa-user text-[10px] text-blueGray-400"></i>
                                            {{ vol.name }}
                                        </span>
                                    </div>
                                </div>

                                <!-- Volunteer Actions for non-admins / members -->
                                <div class="mt-5" *ngIf="currentUser">
                                    <button *ngIf="!isUserRegistered(selectedEvent)"
                                        (click)="registerAsVolunteer(selectedEvent)"
                                        class="w-full py-3 px-4 bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-xl shadow-md hover:shadow-lg transition-all duration-150 flex items-center justify-center gap-2">
                                        <i class="fa fa-hand-holding-heart"></i>
                                        Register as Volunteer
                                    </button>
                                    <button *ngIf="isUserRegistered(selectedEvent)"
                                        (click)="unregisterAsVolunteer(selectedEvent)"
                                        class="w-full py-3 px-4 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-xl shadow hover:shadow-md transition-all duration-150 flex items-center justify-center gap-2">
                                        <i class="fa fa-hand-holding-heart"></i>
                                        Cancel Registration
                                    </button>
                                </div>
                            </div>

                            <!-- If volunteers are NOT requested -->
                            <ng-template #noVolunteers>
                                <div class="text-center py-4 text-sm text-blueGray-500 italic">
                                    No volunteers are requested for this event.
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

@if (loadingProfile) {
<div class="fixed inset-0 bg-gray-900 bg-opacity-30 flex justify-center items-center z-50">
    <div class="bg-white px-6 py-4 rounded-xl shadow-xl flex items-center gap-3 border border-blueGray-100">
        <app-loading-dots color="bg-primary-500"></app-loading-dots>
        <span class="text-sm font-semibold text-primary-500">Loading Profile...</span>
    </div>
</div>
}